"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit"),
    _classnames = _interopRequireDefault(require("classnames")),
    _utils = require("../../../../../../../../../../../utils");

require("../styles/_viewers.scss");

function Viewers(_ref) {
  var viewers = _ref.viewers,
      totalViewers = viewers.length;
  return _react["default"].createElement("div", {
    className: "viewers"
  }, viewers.slice(0, 3).reverse().map(function (viewer, index) {
    var _getUser = (0, _utils.getUser)(viewer),
        userId = _getUser.userId,
        name = _getUser.name,
        imageUrl = _getUser.imageUrl,
        showOverlay = 3 < totalViewers && 0 === index;

    return _react["default"].createElement("div", {
      key: userId,
      className: (0, _classnames["default"])("viewers__viewer", {
        "viewers__viewer--with-more": showOverlay
      })
    }, _react["default"].createElement(_uiKit.Image, {
      height: "20px",
      width: "20px",
      circular: !0,
      imageUrl: imageUrl,
      placeholderText: name,
      placeholderTextSize: 9,
      backgroundSize: "cover"
    }), showOverlay ? _react["default"].createElement("span", {
      className: "viewers__viewer__quantity"
    }, "+".concat(totalViewers - 2)) : null);
  }), _react["default"].createElement("span", {
    className: "viewers__total"
  }, "".concat(totalViewers, " VIEWERS")));
}

var _default = (0, _react.memo)(Viewers);

exports["default"] = _default;